export const backgroundColor = "#FFFFFF";

export const darkModeBGColor = "#262835";